module.exports = __webpack_public_path__ + "img/image.92e92ce2.png";